import { emptyString } from 'react-select/src/utils';
import isIE from 'services/isIE';
import 'services/replaceWithPolyfill';
import 'services/removePolyfill';
import { CALCULATED_LINE_HEIGHT_OFFSET } from 'styles/variables';
import getStore from 'services/getStore';

let linksShouldPopup = false;

const lineBreak = () => {
  const _ = document.createElement('span');
  _.className = 'chameleon-line-break';
  _.style.display = 'block';
  _.style.visibility = 'hidden';
  _.innerHTML = '&#65279;';

  return _;
};

const updateReadOnlyText = containerElement => {
  if (!containerElement) {
    return;
  }

  // adding in the selector for multichoice answers
  // so they can receive the same formatting
  // they have always had the chamelon-text class removed because their styles are local
  //
  const chameleonText = Array.from(
    containerElement.querySelectorAll(
      '.chameleon-text *, .chameleon-text-multichoice-answer *'
    )
  );

  chameleonText.forEach((entry: any) => {
    // updated
    // if entry is a paragraph specifically and has no content
    // that's slate adding the empty p ( which would have no height )
    // we replace it with our lineBreak

    if (entry.tagName.toLowerCase() === 'p' && !entry.innerText.toString()) {
      entry.replaceWith(lineBreak());
    }

    // since we need to clear out any other tags that could interfere with screen readers
    //
    if (
      ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'].includes(entry.tagName.toLowerCase())
    ) {
      // because slate wraps the p tag ( which is the content ) with the alignment div
      // we remove the div and set the appropriate textAlign style on the heading itself
      const textAlignments = Array.from(entry.querySelectorAll('div'));
      textAlignments.forEach((div: any) => {
        if (div.className.includes('chameleon-text-align')) {
          let dataType = div.getAttribute('data-type');

          const rE = new RegExp(
            `<div class="${div.className}" data-type="${dataType}">`,
            'g'
          );

          div.outerHTML = div.outerHTML.replace(rE, '');

          if (dataType) {
            dataType = dataType.replace('textAlign', '').toLowerCase();
          }

          entry.style.textAlign = dataType;
        }
      });

      const pTags = Array.from(entry.querySelectorAll('p'));
      pTags.forEach((p: any) => {
        if (p.innerText.toString()) {
          p.outerHTML = p.outerHTML
            .replace(/\<p data-type=\"paragraph\"\>/g, '')
            .replace(/\<\/p\>/g, '<br>');
        }
      });
    }

    if (entry.dataset.type === 'indent') {
      const closestLi = entry.closest('li');

      if (closestLi) {
        closestLi.classList.add('indent');
      } else {
        entry.classList.add('indent-alt');
      }
    }

    // if ul, ol is empty. remove it
    if (['ul', 'ol'].includes(entry.tagName.toLowerCase())) {
      if (!entry.innerHTML || !entry.innerText) {
        // entry.remove();
        // console.log(entry);
      }
    }

    // if li doesn't have a span wrapping content. is old way
    // update
    if (entry.tagName.toLowerCase() === 'li') {
      entry.classList.remove('chameleon-li');
      const liInnerHTML = entry.innerHTML;
      entry.innerHTML = `<span>${liInnerHTML}</span>`;
    }

    if (entry.tagName.toLowerCase() === 'a') {
      const spans = Array.from(entry.querySelectorAll('span'));
      spans.forEach((span: any) => {
        // we remove the color if it's been set
        // since it creates conflict with the link colors and causes confusion
        span.style.color = '';
      });
    }

    const fontSizeSpans = Array.from(
      entry.querySelectorAll('[data-type="fontSize"]')
    );

    fontSizeSpans.forEach((s: any) => {
      const fontSize = parseInt(window.getComputedStyle(s).fontSize, 10);
      const calculatedLineHeight =
        fontSize <= 18 ? 1.5 : fontSize * CALCULATED_LINE_HEIGHT_OFFSET;
      //
      s.style.lineHeight = `${calculatedLineHeight}px`;
    });

    if (isIE()) {
      if (entry.style.fontFamily === '') {
        entry.style.fontFamily = '';
      }
    }
  });

  chameleonText.forEach((entry: any) => {
    entry.innerHTML = entry.innerHTML
      .replace(/…/g, '&hellip;')
      .replace(/—/g, '&mdash;')
      .replace(/–/g, '&ndash;');
  });

  chameleonText.forEach((entry: any) => {
    entry.innerHTML = entry.innerHTML
      .replace(/…/g, '&hellip;')
      .replace(/—/g, '&mdash;')
      .replace(/–/g, '&ndash;');
  });

  // chameleonText.forEach((entry: any) => {
  //   entry.innerHTML = entry.innerHTML.replace(
  //     /\$\$(.*?)\$\$/g,
  //     // getStore().getState().moduleVariables?.learnerName
  //     window['moduleVariables']?.learnerName
  //   );
  // });

  const ulols: HTMLElement[] = Array.from(
    containerElement.querySelectorAll(
      '.chameleon-text div > ul, .chameleon-text div > ol, .chameleon-text-multichoice-answer div > ul, .chameleon-text-multichoice-answer div > ol'
    )
  );

  // console.log(ulols);

  ulols.forEach((ulol: HTMLElement) => {
    let ulol_: HTMLElement[] = Array.from(ulol.querySelectorAll('ul, ol'));
    ulol_.reverse();
    // const chameleonTextReversed = [...Array.from(ulol_)].reverse();

    ulol_.forEach((entry: HTMLElement) => {
      if (['ul', 'ol'].includes(entry.tagName.toLowerCase())) {
        // console.log(entry, entry.previousSibling);

        const previousSibling = entry.previousSibling as HTMLElement;

        if (!previousSibling) {
          return;
        }

        let closestLi;

        const previousSiblingTagName = previousSibling?.tagName?.toLowerCase();

        if (previousSiblingTagName === 'li') {
          closestLi = previousSibling;
        } else if (['ul', 'ol'].includes(previousSiblingTagName)) {
          // console.log(previousSibling, 'is of type :', previousSibling.tagName);
          closestLi = previousSibling.lastChild;
        }

        // add these additioanal checks for if there have been other nodes not appendChildable
        //
        if (closestLi && closestLi?.tagName && closestLi?.appendChild) {
          closestLi?.appendChild(entry);
        }
      }
    });
  });

  if (!linksShouldPopup) {
    let IS_POPUP;

    const oldWidth = window.innerWidth;
    const oldHeight = window.innerHeight;

    window.resizeBy(-1, -1);

    setTimeout(() => {
      const newWidth = window.innerWidth;
      const newHeight = window.innerHeight;

      if (newWidth !== oldWidth && newHeight !== oldHeight) {
        IS_POPUP = true;
        window.resizeBy(1, 1);
      }
    }, 1000 / 60);

    document.addEventListener('click', (e: any) => {
      if (e.target.tagName.toLowerCase() === 'a') {
        const link = e.target;
        const { href, target } = link;

        if (IS_POPUP && target === '_blank') {
          // if we're in a popup context. . .
          e.preventDefault();
          //
          link.setAttribute('target', 'popup');

          window.open(
            href,
            'popup',
            'width=' + screen.width + ', height=' + screen.height
          );
        }
      }
    });
    linksShouldPopup = true;
  }

  console.log();
};

export default updateReadOnlyText;
